var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "template-card" }, [
    _c("iframe", {
      ref: "iframe",
      staticClass: "template-preview",
      attrs: { src: _vm.previewUrl }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }